import React, { useState } from 'react';
import * as S from './styles';
// import { DatePicker } from 'antd';
import AllAccounts from './AllAccounts';

import OrganizationAccount from './OrganizationAccount';
import IndividualAccount from './IndividualAccount';
import StudentAccount from './StudentAccount';
import BookCode from './BookCode';
import Lessons from './Lessons';
import Assessment from './Assessment';
import { FiBook, FiBookOpen, FiHome, FiPenTool, FiUser, FiUsers } from 'react-icons/fi';
import { FaGraduationCap } from 'react-icons/fa';

const AdiSuperAdminDashboard = () => {
  const viewOptions = ['Static', 'Compare', 'Average'];
  //const [visibilityMap, setVisibilityMap] = useState<Record<string, boolean>>({});

  const reportOptions = [
    'All Accounts',
    'Organization Accounts',
    'Individual Accounts',
    'Student Accounts',
    'Lessons',
    'Assessments',
    'Book Code Use',
  ];

  // const reportOptionsV2 = [
  //   'Lessons',
  //   'Assessments',
  // ];
  const [selectedView, setSelectedView] = useState('Static');
  const [selectedReport, setSelectedReport] = useState('All Accounts');


  




  return (
    <S.Container>
      <S.Sidebar>
        <S.SidebarHeader>View</S.SidebarHeader>
        <S.ToggleGroup>
          {viewOptions.map((option) => (
            <S.ToggleItem
              key={option}
              selected={selectedView === option}
              onClick={() => setSelectedView(option)}
            >
              {option}
            </S.ToggleItem>
          ))}
        </S.ToggleGroup>

        <S.SidebarHeader>Report</S.SidebarHeader>
        <S.SidebarList>
  {reportOptions.map((option) => (
    <S.SidebarItem
      key={option}
      selected={selectedReport === option}
      onClick={() => setSelectedReport(option)}
    >
      <S.SidebarItemContent>
        {/* Only show icon if it is "All Accounts" */}
        {option === 'All Accounts' && (
          <S.IconCircle selected={selectedReport === option}>
            <FiUsers size={16}  />
          </S.IconCircle>
        )}
        {option === 'Organization Accounts' && (
          <S.IconCircle selected={selectedReport === option}>
            <FiHome size={16}  />
          </S.IconCircle>
        )}
                {option === 'Individual Accounts' && (
          <S.IconCircle selected={selectedReport === option}>
            <FiUser size={16}  />
          </S.IconCircle>
        )}
        {option === 'Student Accounts' && (
          <S.IconCircle selected={selectedReport === option}>
            <FaGraduationCap  size={16}  />
          </S.IconCircle>
        )}
        {option === 'Lessons' && (
          <S.IconCircle selected={selectedReport === option}>
            <FiBookOpen size={16}  />
          </S.IconCircle>
        )}
        {option === 'Assessments' && (
          <S.IconCircle selected={selectedReport === option}>
            <FiPenTool size={16}  />
          </S.IconCircle>
        )}
        {option === 'Book Code Use' && (
          <S.IconCircle selected={selectedReport === option}>
            <FiBook size={16} />
          </S.IconCircle>
        )}
        <span>{option}</span>
      </S.SidebarItemContent>
    </S.SidebarItem>
  ))}
</S.SidebarList>
      </S.Sidebar>

      <S.MainContent>
      
        {(
          <>
            {selectedReport === 'All Accounts' && (
              <AllAccounts
                view={selectedView}
                report={selectedReport}
                //startDate={selectedDate ? selectedDate.toISOString() : new Date().toISOString()}
              />
            )}
            {selectedReport === 'Organization Accounts' && (
              <OrganizationAccount
                view={selectedView}
                //startDate={selectedDate ? selectedDate.toISOString() : new Date().toISOString()}
              />
            )}
            {selectedReport === 'Individual Accounts' && (
              <IndividualAccount
                view={selectedView}
                //startDate={selectedDate ? selectedDate.toISOString() : new Date().toISOString()}
              />
            )}
            {selectedReport === 'Student Accounts' && (
              <StudentAccount
                view={selectedView}
               // startDate={selectedDate ? selectedDate.toISOString() : new Date().toISOString()}
              />
            )}
            {selectedReport === 'Lessons' && (
              <Lessons
                view={selectedView}
               // startDate={selectedDate ? selectedDate.toISOString() : new Date().toISOString()}
              />
            )}
            {selectedReport === 'Assessments' && (
              <Assessment
                view={selectedView}
               // startDate={selectedDate ? selectedDate.toISOString() : new Date().toISOString()}
              />
            )}
            {selectedReport === 'Book Code Use' && (
              <BookCode
                view={selectedView}
               // startDate={selectedDate ? selectedDate.toISOString() : new Date().toISOString()}
              />
            )}
          </>
        )}



        {/* {selectedView === 'Compare' && (
          <AllAccounts
            view={selectedView}
            startDate={selectedDate ? selectedDate.toISOString() : new Date().toISOString()}
          />
        )}


        {selectedView === 'Average' && (
          <AllAccounts
            view={selectedView}
            startDate={selectedDate ? selectedDate.toISOString() : new Date().toISOString()}
          />

        )} */}


      </S.MainContent>
    </S.Container>
  );
};

export default AdiSuperAdminDashboard;
